<template>
  <div>
    <div class="btn-float" @click="meetingDialog = true">
      <i class="icon-add">+</i>
    </div>
    <vue-bottom-dialog v-model="meetingDialog" :height="200">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <h2 class="ml-2">Select Date</h2>
          </div>
          <div class="col-6 text-right">
            <a class="outline-default mr-3" @click="meetingDialog = false"> Cancel </a>
            <b-button size="sm" variant="outline-default outline-default-primary" @click="loadDetailsModal()" :disabled="!meeting.date"> Next </b-button>
          </div>
          <div class="col-12">
            <div class="wrapper-radio-calender">
              <b-form-group>
                <input type="datetime-local" class="form-control" placeholder="Date" v-model="meeting.date" />
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </vue-bottom-dialog>
    <b-modal id="add-details" centered :hide-header="true">
      <h2 class="title mb-3">Add Details</h2>
      <textarea v-model="meeting.comment" name="" id="" cols="30" rows="10" class="form-control border rounded-sm"></textarea>
      <div class="form-group p-2 mb-1">
        <CameraImageCapture ref="cameraCapture" />
      </div>
      <div class="form-group p-2 mb-1">
        <label>My Location<span class="text-danger">*</span></label>
        <b-form-input type="text" v-model="meeting.location" readonly required placeholder="Find My Location"></b-form-input>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="row w-100">
          <div class="col-6">
            <label for="file">
              <span class="info"> {{ meeting.attachment ? meeting.attachment.name : "Add Questionnaire" }}</span>
              <b-form-file type="file" ref="file" id="file" v-model="meeting.attachment"> </b-form-file>
            </label>
          </div>
          <div class="col-6 text-right">
            <b-button size="sm" variant="outline-default" @click="cancel()">
              Cancel
            </b-button>
            <b-button size="sm" variant="outline-default outline-default-primary" @click="createMeeting" :disabled="!meeting.location">
              <span>Submit</span>
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  components: {
    CameraImageCapture: () => import('@/components/Forms/CameraImageCapture.vue')
  },
  data() {
    return {
      meetingDialog: false
    }
  },
  props: {
    meeting: {
      type: Object,
      required: true
    }
  },
  methods: {
    cancel() {
      this.meetingDialog = false;
      this.$refs.cameraCapture.stopCameraStream();
      this.$bvModal.hide('add-details');
    },
    loadDetailsModal(){
      this.meetingDialog = false;
      this.getCurrentPosition();
      this.$bvModal.show('add-details');
    },
    createMeeting() {
      this.meeting.executive_image = this.$refs.cameraCapture.finalImage;
      if (!this.meeting.executive_image) {
        this.$refs.cameraCapture.checkPhoto = true;
        return;
      } else {
        this.$refs.cameraCapture.checkPhoto = false;
      }
      let formData = new FormData();
      formData.append('lead_uuid', this.$route.params.id);
      for (var key in this.meeting) {
        if (this.meeting[key] != null) {
          formData.append(key, this.meeting[key])
        }
      }
      this.$axios.post('meetings',
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        .then(res => {
          this.$parent.meeting = {}
          this.$parent.fetchBrokerDetail();
          this.meetingDialog = false;
          this.$refs.cameraCapture.stopCameraStream();
          this.$bvModal.hide('add-details');
          swal({
            title: "Created!",
            icon: "success"
          });
        })
        .catch(err => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error"
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error"
            });
          }
        })
    },
    getCurrentPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.meeting.meeting_executive_lat = position.coords.latitude;
          this.meeting.meeting_executive_long = position.coords.longitude;
          this.getStreetAddressFrom(position.coords.latitude, position.coords.longitude);
        }, (error) => {
          console.log(error);
        }, { timeout: 10000, enableHighAccuracy: true, maximumAge: 0 });
      } else {
        //Geolocation is not supported by this browser
        console.log('Geolocation is not supported by this browser');
      }
    },
    async getStreetAddressFrom(lat, long) {
      try {
        const { data } = await this.$axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          long +
          "&key=AIzaSyCDi6loOYUz1fXzMJpqI_83UlcdPrp86Fg"
        );
        if (data.error_message) {
          console.log(data.error_message)
        } else {
          this.$set(this.meeting,'location',data.results[0].formatted_address)
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>>
<style scoped>
</style>